export default "__VITE_ASSET__3s9v64XR__"